/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_ClaimInputs */

const en_landing_drift_claim = /** @type {(inputs: Landing_Drift_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`94-99% of untouched pixels stay identical, pass after pass.`)
};

const zh_landing_drift_claim = /** @type {(inputs: Landing_Drift_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一轮又一轮，未修改区域 94%-99% 的像素保持完全一致。`)
};

/**
* | output |
* | --- |
* | "94-99% of untouched pixels stay identical, pass after pass." |
*
* @param {Landing_Drift_ClaimInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_claim = /** @type {((inputs?: Landing_Drift_ClaimInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_ClaimInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_claim(inputs)
	return zh_landing_drift_claim(inputs)
});
export { landing_drift_claim as "landing.drift.claim" }